import { camelizeKeys } from 'humps';
import { jwtDecode } from 'jwt-decode';
import { z } from 'zod';

import UserSchema from '@/modules/auth/userSchema';

type UserPayload = z.infer<typeof UserSchema>;

const parseJwt = (token: string): UserPayload | null => {
  if (!token) return null;
  try {
    const decodedToken = jwtDecode(token);
    const camelCaseDecodedToken = camelizeKeys(decodedToken);
    const validatedToken = UserSchema.safeParse(camelCaseDecodedToken);
    if (validatedToken.success) {
      return validatedToken.data;
    }
    return null;
  } catch {
    return null;
  }
};
export default parseJwt;
